import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 20H32",
		stroke: "currentColor",
		strokeWidth: 3,
		strokeMiterlimit: 10,
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 8V32",
		stroke: "currentColor",
		strokeWidth: 3,
		strokeMiterlimit: 10,
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
